module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"manufacturer":"Manufacturer","name":"Name","category":"Category","weight":"Weight","count":"Count","worn":"Worn","pack":"Packed"},"de":{"manufacturer":"Hersteller","name":"Name","category":"Kategorie","weight":"Gewicht","count":"Anzahl","worn":"Getragen","pack":"Gepackt"}}')
  delete Component.options._Ctor
}
